import { useState, useEffect } from "react";

const useDurationEvent = (durationData) => {
  const [durationList, setDurationList] = useState([]);

  // 백엔드 데이터가 왔을 때, 해당 값으로 State 초기화
  useEffect(() => {
    if (durationData) {
      const tmpList = [];
      durationData.forEach((elem) => {
        const tmp = [];
        tmp.push(elem[0] === "break" ? "break" : null);
        tmp.push(elem[1]);
        tmp.push(elem[0] === "break" ? "empty" : elem[2]);
        tmp.push(elem[0] === "break" ? "empty" : elem[3]);
        tmp.push(elem[0] === "break" ? "empty" : elem[4]);
        tmpList.push(tmp);
      });
      setDurationList(tmpList);
    }
  }, [durationData]);

  // ===== 듀레이션 관련 이벤트 =====

  const setDuration = (e, type, index) => {
    const tmpList = [...durationList];
    const tmpElem = [...tmpList[index]];
    const value = e.target.value;

    if (type === 1) {
      // Minute 수정
      tmpElem[type] = value;
    } else if (type === 2) {
      // SB 수정
      tmpElem[type] = value;
      tmpElem[type + 1] = value * 2;
      tmpElem[type + 2] = value * 2;
    } else if (type === 3) {
      // BB 수정
      tmpElem[type] = value;
      tmpElem[type + 1] = value;
    } else if (type === 4) {
      // Ante 수정
      tmpElem[type] = value;
    }

    tmpList[index] = tmpElem;
    setDurationList(tmpList);
  };

  const createDurationEvent = () => {
    const tmpList = [...durationList];

    tmpList.push([null, null, null, null, null]);
    setDurationList(tmpList);
  };

  const createBreakEvent = () => {
    const tmpList = [...durationList];

    tmpList.push(["break", null, "empty", "empty", "empty"]);
    setDurationList(tmpList);
  };

  const deleteDurationEvent = (index) => {
    const tmpList = [...durationList];

    tmpList.splice(index, 1);
    setDurationList(tmpList);
  };

  const upperDurationEvent = (index) => {
    const tmpList = [...durationList];

    if (index > 0) {
      let tmp = tmpList[index - 1];
      tmpList[index - 1] = tmpList[index];
      tmpList[index] = tmp;
    }
    setDurationList(tmpList);
  };

  const downDurationEvent = (index) => {
    const tmpList = [...durationList];

    if (index < tmpList.length - 1) {
      let tmp = tmpList[index + 1];
      tmpList[index + 1] = tmpList[index];
      tmpList[index] = tmp;
    }
    setDurationList(tmpList);
  };

  return [
    durationList,
    setDuration,
    createDurationEvent,
    createBreakEvent,
    deleteDurationEvent,
    upperDurationEvent,
    downDurationEvent,
  ];
};

export default useDurationEvent;
